import React, { useEffect, useState } from 'react';

function LogoutButton() {
  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('username');
    window.location.href = "/"; // Redirect to homepage after logout
  };

  const [currentActive, setCurrentActive] = useState(0);
  const [isBodyLoggedIn, setIsBodyLoggedIn] = useState(false);
  const duration = 3000;

  const newsItems = [
    { id: 1, content: 'Please be inform that sg8.casino is the sole authorized website for SG8 casino.' },
    { id: 2, content: 'JILI, now available at SG8 Casino! Embark on an unforgettable gaming adventure and win incredible prizes!' },
    { id: 3, content: 'Unlock Your Rewards: Up to 150% Deposit Bonus on Your 1st to 5th Deposits, Maximum of Php 3,888!' },
  ];

  const totalNews = newsItems.length;

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentActive(prevActive => (prevActive + 1) % totalNews);
    }, duration);

    return () => clearInterval(intervalId); 
  }, [totalNews, duration]);

  useEffect(() => {
    setIsBodyLoggedIn(document.body.classList.contains('isLoggedIn'));
  }, []);

  return (
    <div className="header-news-logout">
      <div className="news-container">
        <div className="news-heading">News:</div>
        {newsItems.map((item, index) => (
          <div key={item.id}>
            <a href="#" className={`news-single ${index === currentActive ? 'active' : ''}`}>{item.content}</a>
          </div>
        ))}
      </div>
      {isBodyLoggedIn && (
        <span className="logout-BTN">
          <a onClick={handleLogout}>
            <img src="/images/logout.webp" alt="logout icon"/>
            <p>LOGOUT</p>
          </a>
        </span>
      )}
    </div>
  );
}

export default LogoutButton;
